import React, { Component } from "react";

class LayoutBlank extends Component {
  render() {
    return <div role="main">{this.props.children}</div>;
  }
}

export default LayoutBlank;
